import { describe, it, expect } from '@jest/globals';
import { getBuiltInSettings } from './getBuiltInSettings.js';
import { builtInSettings } from './builtInSettings.js';

describe('getBuiltInSettings', () => {
  it('returns the settings for a package (correct version)', () => {
    // verify test assumptions: scheduler has multiple sets of settings
    expect(builtInSettings.scheduler).toBeDefined();
    expect(Object.keys(builtInSettings.scheduler || {}).length).toBeGreaterThan(1);

    const settings = getBuiltInSettings({ name: 'scheduler', version: '0.9.0' });
    expect(settings).toEqual({
      packageJson: {
        exports: {
          '.': './index.js',
          './tracing': './tracing.js',
        },
      },
    });
  });

  it('returns the settings for a package with packageSettings only', () => {
    const settings = getBuiltInSettings({ name: 'asap', version: '2.0.6' });
    expect(settings).toEqual({
      packageSettings: {
        bundler: 'ori',
      },
    });
  });

  it('returns the settings for a package with both packageJson and packageSettings', () => {
    const settings = getBuiltInSettings({ name: 'gql.tada', version: '1.0.0' });
    expect(settings).toEqual({
      packageSettings: {
        excludedDependencies: ['@0no-co/graphqlsp', '@gql.tada/cli-utils', '@gql.tada/internal', 'typescript'],
      },
      packageJson: {
        exports: './dist/gql-tada.mjs',
      },
    });
  });

  it("returns undefined when version doesn't match", () => {
    // verify test assumptions
    expect(builtInSettings.scheduler).toBeDefined();

    const settings = getBuiltInSettings({ name: 'scheduler', version: '1.0.0' });
    expect(settings).toBeUndefined();
  });

  it('returns undefined when package version is out of range for settings', () => {
    const settings = getBuiltInSettings({ name: 'scheduler', version: '100.0.0' });
    expect(settings).toBeUndefined();
  });

  it('returns undefined when there are no applicable settings', () => {
    const settings = getBuiltInSettings({ name: 'nope', version: '1.0.0' });
    expect(settings).toBeUndefined();
  });
});
